// Importe o tipo de erro do Axios para garantir a precisão
import { AxiosError } from 'axios';

/**
 * Valida se um erro é um erro de rede do Axios.
 * @param error O erro a ser validado, esperado ser um AxiosError.
 * @returns {boolean} Verdadeiro se for um erro de rede.
 */
export default function isNetworkErrorValidation(error: AxiosError): boolean {
  // O TypeScript agora sabe que 'error' tem uma propriedade opcional 'code' do tipo string.
  return error?.code === 'ERR_NETWORK';
}